<template>
    <main class="main">
        <!-- ======= Breadcrumbs ======= -->
        
        <section id="breadcrumbs" class="breadcrumbs">
            <div class="container">
                <ol>
                <li><a href="/">ACCUEIL</a></li>
                <li>LISTE DES DOSSIERS</li>
                </ol>
                <div class="d-flex justify-space-between">
                    <h2>LISTE DES DOSSIERS</h2>
                    <div class="mr-3"><router-link class="btn bg-green-darken-4" to="/supplier/dossiers/create"><i class="bi bi-plus-square-fill" title="Creer un nouveau dossier"></i> NOUVEAU DOSSIER</router-link></div>
                </div>
            </div>
        </section><!-- End Breadcrumbs -->
        <div class="container">
            <div class="d-flex justify-center gap-3">
                <div v-for="(dossier,index) in dossiers" :key="index" class="card bg-light">
                    <div class="card-body">
                        <router-link :to="{name:'supplier_dossier',params:{tkn:dossier.token}}">
                            <div class="text-center">
                                <img v-if="dossier.entreprise!=null" class="img img-circle" :src="dossier.entreprise.photo" style="height: 100px; width: 100px;" alt="">
                                <h6 v-if="dossier.entreprise!=null" >{{ dossier.entreprise.name }}</h6>
                                <h4><strong>{{ dossier.montant_transaction }}</strong></h4>
                                <small>{{ dossier.created }}</small>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import axios from "axios";
export default {
    name:"IndexPreseed",
    data(){
        return {
            user:this.$store.state.auth.user,
            dossiers:[]
        }
    },
    methods:{
        async load(){
            await axios.get(this.path+'supplier/dossiers')
                        .then((res)=>this.dossiers=res.data)
                        .catch((err)=>console.error(err));
        }
    },
    mounted(){
        this.load().then(()=>{
            this.dossiers.map((d,i)=>{
                console.log(i)
                console.log(d);
                let n = d.type.id;
                d.bg = 'bg-gradient-teal';
                if(n==1){
                    d.bg = 'bg-danger';
                }
                if(n==2){
                    d.bg = 'bg-yellow-darken-4';
                }
                if(n==3){
                    d.bg = 'bg-blue-darken-4';
                }
                if(n==4){
                    d.bg ='bg-dark';
                }
                if(n==5){
                    d.bg = 'bg-gradient-cyan';
                }
                if(n==6){
                    d.bg = 'bg-green-darken-4';
                }
                console.log(d);
                return d;
            })
        })
        
    },
    computed:{
    }

}
</script>

<style scoped>
    .badge{
        background-color: #3d9970;
        color: #fff;
    }
    .breadcrumbs a{
        color: #3d9970;
        text-decoration: none;
    }
    a{
        color: #3d9970;
        text-decoration: none;
    }

    div.card-body a {
        color: inherit;
    }

    a.btn{
        color:#fff;
    }
</style>